/*
 * bfcm-remind.js — BFCM 2026 "Add to calendar" (markup + config: snippets/bfcm-remind.liquid).
 *
 * Event: on the list (rastah_bfcm_unlock / rastah_bfcm_preview, cookie or
 * localStorage) → early access; everyone else → the public launch.
 * [data-bfcm-remind-event="ea"] pins early access (the gate's success screen).
 *
 * One tap:
 *   iPhone / iPad (iPadOS reports a Mac UA: Mac + touch = iOS) and Mac Safari
 *     → the served .ics (text/calendar) in the same tab: iOS shows "Add to Calendar",
 *       Mac Safari hands it to Calendar;
 *   everything else → Google Calendar, prefilled, new tab.
 *   iOS in-app browsers (Instagram, Facebook, TikTok…: any iOS web view without "Safari/"
 *     in its UA) can't show the calendar sheet, so the .ics opens in Safari instead
 *     (x-safari-https://, iOS 17+). If the page is still showing 1.6s later (older iOS,
 *     or the app blocked it), the "Other calendar" options open so Google is one tap away.
 * Other calendars: Apple / Outlook (.ics) · Google · Outlook.com.
 *   Success screen: "Other calendar" swaps the link row for them.
 *   Hub chip ([data-bfcm-remind-pop] ▾): a floating list it toggles; closes on an outside tap,
 *   Escape, scroll or a pick.
 * Hidden once the event has started (a cached page late on the day).
 *
 * dataLayer: { event: 'bfcm_calendar_add', method: 'ics'|'google'|'outlook',
 *              bfcm_event: 'early_access'|'launch', surface: 'hub'|'gate', platform }
 * API: window.RastahBFCMRemind = { available(key), sync(), eventKey(el), urls(key), platform() }
 */
(function () {
  'use strict';
  if (window.RastahBFCMRemind) return;
  var cfg;
  try { cfg = JSON.parse(document.getElementById('bfcm-remind-config').textContent); } catch (e) { return; }
  var EV = cfg.events || {};

  var ua = navigator.userAgent || '';
  var IOS = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1);
  var MAC_SAFARI = !IOS && /Macintosh/.test(ua) && /Safari\//.test(ua) && !/Chrome\/|Chromium|CriOS|FxiOS|Firefox\/|Edg\/|OPR\//.test(ua);
  var IN_APP = IOS && (!/Safari\//.test(ua) || /Instagram|FBAN|FBAV|FB_IAB|FBIOS|BytedanceWebview|musical_ly|TikTok|Snapchat|Pinterest|LinkedInApp|\bLine\/|GSA\//.test(ua));
  function platform() { return IN_APP ? 'ios_in_app' : IOS ? 'ios' : MAC_SAFARI ? 'mac_safari' : /Android/.test(ua) ? 'android' : 'desktop'; }
  function primary() { return IOS || MAC_SAFARI ? 'ics' : 'google'; }

  function listed() {
    if (/(?:^|;\s*)rastah_bfcm_(?:unlock|preview)=1/.test(document.cookie || '')) return true;
    try { return !!(localStorage.getItem('rastah_bfcm_unlock') || localStorage.getItem('rastah_bfcm_preview')); } catch (e) { return false; }
  }
  function eventKey(box) {
    var f = box && box.getAttribute('data-bfcm-remind-event');
    if (f === 'ea') return 'early_access';
    if (f === 'launch') return 'launch';
    return listed() ? 'early_access' : 'launch';
  }
  function available(key) {
    var ev = EV[key];
    return !!(ev && ev.start > 0 && ev.end > ev.start && Date.now() < ev.start);
  }

  // The hub on the shopper's current domain (rastah.co, pk.rastah.co, row.rastah.co…).
  // Blank = homepage; "rastah.co/x" without https:// gets it added (same rules as the .ics files).
  function link() {
    var l = String(cfg.link || '').trim() || '/';
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(l)) return l;
    if (l.charAt(0) !== '/' && l.split('/')[0].indexOf('.') > -1) return 'https://' + l;
    return location.origin + (l.charAt(0) === '/' ? l : '/' + l);
  }
  function iso(ms) { return new Date(ms).toISOString().replace(/\.\d{3}Z$/, 'Z'); }   // 2026-11-18T17:00:00Z
  function stamp(ms) { return iso(ms).replace(/[-:]/g, ''); }                         // 20261118T170000Z
  function enc(s) { return encodeURIComponent(s || ''); }
  function details(ev) { return (ev.desc ? ev.desc + '\n' : '') + link(); }

  function url(key, method) {
    var ev = EV[key];
    if (!ev) return '';
    if (method === 'ics') return IN_APP ? String(ev.ics).replace(/^https:\/\//, 'x-safari-https://') : ev.ics;
    if (method === 'google') {
      return 'https://calendar.google.com/calendar/render?action=TEMPLATE' +
        '&text=' + enc(ev.title) +
        '&dates=' + stamp(ev.start) + '/' + stamp(ev.end) +
        '&details=' + enc(details(ev)) +
        '&location=' + enc(link());
    }
    return 'https://outlook.live.com/calendar/0/action/compose' +
      '?subject=' + enc(ev.title) +
      '&startdt=' + enc(iso(ev.start)) +
      '&enddt=' + enc(iso(ev.end)) +
      '&body=' + enc(details(ev)) +
      '&location=' + enc(link());
  }

  function setLink(a, key, method) {
    a.href = url(key, method);
    a.setAttribute('data-bfcm-remind-method', method);
    if (method === 'ics') {
      // Same tab: iOS keeps the page and shows its calendar sheet on top.
      a.removeAttribute('target');
      a.removeAttribute('rel');
    } else {
      a.target = '_blank';
      a.rel = 'noopener';
    }
  }

  function sync(box) {
    var key = eventKey(box);
    if (!available(key)) { box.hidden = true; return; }
    box.hidden = false;
    box.setAttribute('data-bfcm-remind-current', key);
    var main = box.querySelector('[data-bfcm-remind-add]');
    if (main) setLink(main, key, primary());
    var alts = box.querySelectorAll('[data-bfcm-remind-menu] a[data-bfcm-remind-method]');
    for (var i = 0; i < alts.length; i++) setLink(alts[i], key, alts[i].getAttribute('data-bfcm-remind-method'));
  }
  function syncAll() {
    var boxes = document.querySelectorAll('[data-bfcm-remind]');
    for (var i = 0; i < boxes.length; i++) sync(boxes[i]);
  }

  function track(method, key, surface) {
    var payload = {
      event: 'bfcm_calendar_add',
      method: method,
      bfcm_event: key,
      surface: surface || 'unknown',
      platform: platform(),
      bfcm_stage: cfg.stage || '',
      page_path: location.pathname + location.search,
      ts: Date.now()
    };
    (window.dataLayer = window.dataLayer || []).push(payload);
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('bfcm_calendar_add', payload);
    } catch (e) {}
  }

  // Success screen: swap "Other calendar" for the three options (same row, nothing shifts).
  // Hub chip: the ▾ toggles a floating list (nothing below moves).
  var popOpen = null;
  function closePop(refocus) {
    var b = popOpen;
    if (!b) return;
    popOpen = null;
    var more = b.querySelector('[data-bfcm-remind-more]');
    var menu = b.querySelector('[data-bfcm-remind-menu]');
    if (menu) menu.hidden = true;
    if (more) {
      more.setAttribute('aria-expanded', 'false');
      if (refocus) { try { more.focus({ preventScroll: true }); } catch (x) {} }
    }
  }
  function openMenu(b, focus) {
    var more = b && b.querySelector('[data-bfcm-remind-more]');
    var menu = b && b.querySelector('[data-bfcm-remind-menu]');
    if (!more || !menu) return;
    sync(b);
    more.setAttribute('aria-expanded', 'true');
    if (more.hasAttribute('data-bfcm-remind-pop')) {
      if (popOpen && popOpen !== b) closePop(false);
      popOpen = b;
      popY = window.pageYOffset;
    } else {
      more.hidden = true;
    }
    menu.hidden = false;
    var first = focus && menu.querySelector('a');
    if (first) { try { first.focus({ preventScroll: true }); } catch (x) {} }
  }
  var popY = 0;
  document.addEventListener('keydown', function (e) {
    if (popOpen && (e.key === 'Escape' || e.key === 'Esc')) closePop(true);
  });
  document.addEventListener('focusin', function (e) {
    if (popOpen && !popOpen.contains(e.target)) closePop(false);
  });
  window.addEventListener('scroll', function () {
    if (popOpen && Math.abs(window.pageYOffset - popY) > 40) closePop(false);
  }, { passive: true });

  // iOS in-app browser: if Safari didn't take over (the page never went to the background),
  // show the other options.
  function fallback(b) {
    var left = false;
    function onHide() { if (document.visibilityState === 'hidden') left = true; }
    function onPageHide() { left = true; }
    document.addEventListener('visibilitychange', onHide);
    window.addEventListener('pagehide', onPageHide);
    setTimeout(function () {
      document.removeEventListener('visibilitychange', onHide);
      window.removeEventListener('pagehide', onPageHide);
      if (!left && document.visibilityState !== 'hidden') openMenu(b, false);
    }, 1600);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var more = t.closest('[data-bfcm-remind-more]');
    if (more) {
      e.preventDefault();
      var mb = more.closest('[data-bfcm-remind]');
      if (more.hasAttribute('data-bfcm-remind-pop') && popOpen === mb) { closePop(false); return; }
      // Keyboard (detail 0) moves focus into the list; a tap leaves it on the chip.
      openMenu(mb, !more.hasAttribute('data-bfcm-remind-pop') || e.detail === 0);
      return;
    }
    // A tap anywhere else closes the hub list.
    if (popOpen && !popOpen.contains(t)) closePop(false);
    var a = t.closest('[data-bfcm-remind] a[data-bfcm-remind-method]');
    if (!a) return;
    var box = a.closest('[data-bfcm-remind]');
    if (popOpen === box) setTimeout(function () { closePop(false); }, 0);
    sync(box); // list state may have changed since load (joined on another tab)
    var method = a.getAttribute('data-bfcm-remind-method');
    track(method, box.getAttribute('data-bfcm-remind-current') || eventKey(box), box.getAttribute('data-bfcm-remind-surface'));
    if (IN_APP && method === 'ics') fallback(box);
  });

  // Joining the list flips "Remind me when it opens" (launch) to early access.
  document.addEventListener('bfcm:unlock', syncAll);
  document.addEventListener('bfcm:unlock-phone', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  window.addEventListener('storage', function (e) { if (/^rastah_bfcm_(unlock|preview)$/.test(e.key || '')) syncAll(); });
  syncAll();

  window.RastahBFCMRemind = {
    available: available,
    sync: syncAll,
    eventKey: eventKey,
    platform: platform,
    urls: function (key) { return { ics: url(key, 'ics'), google: url(key, 'google'), outlook: url(key, 'outlook'), primary: primary() }; }
  };
})();
